import projects from "../json/projects.json"
import { Link, useNavigate } from "react-router-dom"
import "../css/Projects.css"

const Projects = () => {

    const navigate = useNavigate()

    return (
        <main className="flex col acenter">
            <h1 className="cspica jscenter">Proyectos</h1>
            <section className="flex wrap gap-20 w90 jcenter">
                {projects.map(project =>
                    <article key={project.id} className="project flex col acenter pointer" onClick={() => navigate("/proyectos/" + project.tag)}>
                        <img className="project-main-image" alt={project.smalltitle} src={"/images/projects/" + project.mainimage}></img>
                        <section className="flex col project-description gap-10 ">
                            <Link to={project.tag} className="project-description-color">{project.smalltitle}</Link>
                            <section className="flex acenter gap-10">
                                <i className="bi bi-caret-right-fill project-icon"></i>
                                <label className="see-more" >Ver más</label>
                            </section>
                        </section>
                    </article>
                )}
            </section>
        </main>
    )
}


export default Projects
